module.exports = __webpack_public_path__ + "static/contactores_1-508ca7e7961e25c68c28a0c3f71acd6c.png";